import { number, object, string } from 'yup';
import { ValidationSchema } from 'enums/CreateProductModalEnums';
import { CategoryOptions } from './ProductModalForm';
export const Fields = [
  {
    name: 'productName',
    placeholder: 'Product Name',
    label: 'Product Name',
    select: false,
    date: false,
    size: 'big',
  },
  {
    name: 'brand',
    placeholder: 'Brand',
    label: 'Brand',
    select: true,
    date: false,
    size: 'big',
  },
  {
    name: 'productNetWeight',
    placeholder: 'Product net weight (excluding packaging)',
    label: 'Product net weight (excluding packaging)',
    select: false,
    date: false,
    size: 'medium',
  },
  {
    name: 'ml',
    placeholder: 'ml',
    label: 'ml',
    select: true,
    date: false,
    size: 'small',
  },
  {
    name: 'productGrossWeight',
    placeholder: 'Product gross weight (g) (Including packaging)',
    label: 'Product gross weight (g) (Including packaging)',
    select: false,
    date: false,
    size: 'big',
  },
  {
    name: 'temperatureControl',
    placeholder: 'Temperature control',
    label: 'Temperature control',
    select: true,
    date: false,
  },
  {
    name: 'reportingPeriodProduction',
    placeholder: 'Reporting period production (units)',
    label: 'Reporting period production (units)',
    select: false,
    date: false,
    size: 'big',
  },
  {
    name: 'percentageProcessingFacilityCostGood',
    placeholder: 'Percentage of processing facility cost of goods sold',
    label: 'Percentage of processing facility cost of goods sold',
    select: false,
    date: false,
    size: 'big',
  },
  {
    name: 'reportingPeriod',
    placeholder: 'Choose reporting period',
    label: 'Choose reporting period',
    select: false,
    date: true,
    size: 'big',
  },
  {
    name: 'processingFacility',
    placeholder: 'Processing facility',
    label: 'Processing facility',
    select: true,
    date: false,
    size: 'big',
  },
  {
    name: 'productDensity',
    placeholder: 'Density of the Product',
    label: 'Density of the Product',
    select: false,
    date: false,
    size: 'big',
  },
];

export const ml: CategoryOptions[] = [
  {
    value: 'ml',
    label: 'ml',
    key: 1,
  },
  {
    value: 'L',
    label: 'L',
    key: 2,
  },
  {
    value: 'kg',
    label: 'kg',
    key: 3,
  },
  {
    value: 'g',
    label: 'g',
    key: 4,
  },
];
export const temperatureControl: CategoryOptions[] = [
  {
    value: 'ambient',
    label: 'Ambient',
    key: 1,
  },
  {
    value: 'frozen',
    label: 'Frozen',
    key: 2,
  },
  {
    value: 'refrigerated',
    label: 'Refrigerated',
    key: 3,
  },
];

export const validationSchema = object({
  productName: string().required(ValidationSchema.ERROR_MESSAGE).nullable(),
  description: string()
    .required(ValidationSchema.ERROR_MESSAGE)
    .test('max-words', ValidationSchema.MAX_WORDS, function (value) {
      if (!value) return true;
      const words = value.trim().split(/\s+/);
      return words.length <= 100;
    })
    .nullable(),
  brand: string().required(ValidationSchema.ERROR_MESSAGE).nullable(),
  productNetWeight: number()
    .required(ValidationSchema.ERROR_MESSAGE)
    .typeError(ValidationSchema.NUMBER),
  ml: string().required(ValidationSchema.ERROR_MESSAGE).nullable(),
  productGrossWeight: number()
    .required(ValidationSchema.ERROR_MESSAGE)
    .typeError(ValidationSchema.NUMBER),
  temperatureControl: string()
    .required(ValidationSchema.ERROR_MESSAGE)
    .nullable(),
  reportingPeriodProduction: number()
    .integer(ValidationSchema.INTEGER)
    .required(ValidationSchema.ERROR_MESSAGE)
    .typeError(ValidationSchema.NUMBER),
  percentageProcessingFacilityCostGood: number()
    .positive(ValidationSchema.MIN)
    .max(100, ValidationSchema.MAX)
    .required(ValidationSchema.ERROR_MESSAGE)
    .typeError(ValidationSchema.NUMBER),
  reportingYear: number()
    .required(ValidationSchema.ERROR_MESSAGE)
    .typeError(ValidationSchema.DATE),
  processingFacility: string()
    .required(ValidationSchema.ERROR_MESSAGE)
    .nullable(),
  productDensity: number()
    .required(ValidationSchema.ERROR_MESSAGE)
    .typeError(ValidationSchema.NUMBER),
});

export const PROCESSING_FACILITY = 'Processing facility';
export const LABEL = 'label';
export const PF_NOT_FOUND_ERROR = 'processing_facility_not_found';
export const DESCRIPTION_ITALIC_TEXT =
  '( This data will be shown on approval report )';
export const FETCH_NEW_PRODUCT_LOADER = 'Fetching parent product...';

export const defaultFileProps = {
  uid: 'image_default_1',
  name: 'prodImage',
};
